import { render, staticRenderFns } from "./Flat.vue?vue&type=template&id=b4525bb4&"
import script from "./Flat.vue?vue&type=script&lang=js&"
export * from "./Flat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports